import React, { Component } from "react";

import { withTranslation } from "react-i18next";
import Select from "react-select";

import { endpoint } from "../../../../commonjs/endpoints";
import { plainSelectStyles } from "../Styles";

class _Cofor10Filter extends Component {
  state = {
    selectedCofor10: [],
    isLoading: true,
    supplierOptions: [],
  };

  componentDidMount() {
    endpoint("statistics:api_suppliers").then((result) => {
      const supplierOptions = result.data
        .map((entry) => ({
          label: entry.cofor10,
          value: entry.id,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      this.setState({
        supplierOptions,
        isLoading: false,
      });
    });
  }

  onSelectSupplier = (options) => {
    const { filter } = this.props;
    filter(options || []);
  };

  render() {
    const { t } = this.props;
    const { isLoading, supplierOptions } = this.state;

    return (
      <label>
        {t("COFOR10")}
        <Select
          defaultValue={t("Choose one or more COFOR10")}
          styles={plainSelectStyles}
          options={supplierOptions}
          isMulti={true}
          closeMenuOnSelect={true}
          className="supplier-select"
          onChange={this.onSelectSupplier}
          isLoading={isLoading}
        />
      </label>
    );
  }
}

export const Cofor10Filter = withTranslation()(_Cofor10Filter);
